
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ICountry } from '@/api/types/catalogue';

@Component({})
export default class TooltipCountryList extends Vue {
    @Prop({ required: true } ) countries!: ICountry[];
}
